import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-read",
  "use": "icon-read-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-read\"><path d=\"m13.209 2.85 7.922 5.434A2 2 0 0 1 22 9.934v9.315a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.944a2 2 0 0 1 .882-1.659l8.078-5.444a2 2 0 0 1 2.249.01ZM20 11.056l-6.863 4.753a2 2 0 0 1-2.137.09l-.14-.09L4 11.057v8.192h16v-8.194ZM12.078 4.5 4.965 9.293l7.034 4.871 7.05-4.883L12.078 4.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol